import AdInsight from './adInsightResource';
import normalizeChartParams from './normalizer/chartNormalizer';
import transformCSV from '../shared/transformers/CSVTransformer';

import transformSelectedChartType from './transformer/selectedChartTypesTransformer';

import transformToCamelCase from '../shared/transformers/toCamelCaseTransformer';
import transformError from '../shared/transformers/errorTransformer';

import campaignIdAndRangeNormalizer from '@/api/shared/normalizers/campaignIdAndRangeNormalizer';

/**
 * It fetches chart data
 * @param {Object} statFilters - The object which represents filters of the stats
 * @param {string} statFilters.campaignId - The campaign ID
 * @param {number[]} statFilters.bids - An array of bids IDs
 * @param {string} statFilters.range - Range of the stats
 * @param {string} statFilters.statType - The type of the data
 */
function createChart(statFilters) {
  const params = normalizeChartParams(statFilters);
  return AdInsight.getStatData(params).then(({ body: { stats } }) => {
    return transformToCamelCase(stats);
  });
}

/**
 * It fetches statBuilderCSV
 * @param {Object} statFilters - The object which represents filters of the CSV
 * @param {string} statFilters.campaignId - The campaign ID
 * @param {number[]} statFilters.bids - An array of bids IDs
 * @param {string} statFilters.range - Range of the stats
 * @param {string} statFilters.statType - The type of the data
 */
function saveStatsBuilderCSV(statFilters) {
  const params = normalizeChartParams(statFilters);
  return AdInsight.saveStatsBuilderCSV(params).then(res => transformCSV(res));
}

/**
 * It fetches campaignOverallCSV
 * @param {string} campaignId - The campaign ID
 * @param {string} range - Range of the stats
 */
function saveOverallCSV(campaignId, range) {
  const params = campaignIdAndRangeNormalizer(campaignId, range);
  return AdInsight.saveOverallCSV(params).then(res => transformCSV(res));
}

function getChartStatTypes() {
  return AdInsight.getChartStatTypes().then(
    ({ body: { stat_types: statTypes = [] } }) => {
      const selected = transformSelectedChartType(statTypes);
      return {
        selected,
        statTypes,
      };
    },
  );
}

/**
 * It fetches campaign overall stats
 * @param {string} campaignId - The campaign ID
 * @param {string} range - Range of the stats
 */
function getCampaignOverallStats(campaignId, range) {
  const params = campaignIdAndRangeNormalizer(campaignId, range);
  return AdInsight.getCampaignOverallStats(params)
    .then(({ body }) => transformToCamelCase(body))
    .catch(transformError);
}

export default {
  // TODO: This should be removed after adding Qomri
  ...AdInsight,
  createChart,
  getChartStatTypes,
  saveOverallCSV,
  saveStatsBuilderCSV,
  getCampaignOverallStats,
};
